import { Box, Grid, Stack, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  CHOOSE_ACCOUNT_TYPE_HEADER,
  CHOOSE_ACCOUNT_TYPE_SUB_HEADER,
  CLIPBOARD_ICON_ID,
  FPACT_CARD_HEADER,
  FPACT_CARD_SUB_HEADER,
  HAP_CARD_HEADER,
  HAP_CARD_SUB_HEADER,
  HAP_ICON_ID,
  LINK_MY_APPLICATION_BUTTON,
  LOG_IN_LINK,
  START_NEW_APPLICATION_BUTTON,
} from "../../../Constants/ChooseAccountTypeConstants";
import {
  ACCOUNT_CREATION_ROUTE,
  BUTTON,
  H1,
  H2,
  LINK_APPLICATION_ROUTE,
  LOGIN_ROUTE,
  NAME_AND_CONTACT_ROUTE,
  P_REGULAR,
  SECONDARY_MAIN
} from "../../../Constants/CommonConstants";
import { clearAccountCreationSlice } from "../../../Features/AccountCreationSlice";
import { clearLinkApplicationSlice } from "../../../Features/LinkApplicationSlice";
import {
  StyledAccountTypeLink,
  StyledClipboardIcon,
  StyledHAPIcon,
} from "../../../Styles/AccountCreation/ChooseAccountType/ChooseAccountTypeStyles";
import { AccountTypeCard } from "./AccountTypeCard";

/**
 * @description Choose Account Type screen that allows the user to choose the application type
 * @returns {ReactNode} Renders the Choose Account Screen Type Screen which lets the user to select the type of application
 */
const ChooseAccountType = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const intl = useIntl();

  const handleLoginClick = () => {
    navigate(`/${LOGIN_ROUTE}`);
  };

  const handleStartApplicationBtnClick = () => {
    dispatch(clearAccountCreationSlice());
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${NAME_AND_CONTACT_ROUTE}`);
  };

  const handleLinkApplicationBtnClick = () => {
    dispatch(clearLinkApplicationSlice());
    navigate(`/${LINK_APPLICATION_ROUTE}`);
  };

  return (
    <Stack spacing={{ xs: 3, md: 6 }}>
      <Stack spacing={2}>
        <Typography
          component={H1}
          variant={H2}
          color={SECONDARY_MAIN}
          id={CHOOSE_ACCOUNT_TYPE_HEADER}
        >
          {intl.formatMessage({ id: CHOOSE_ACCOUNT_TYPE_HEADER })}
        </Typography>
        <Typography
          variant={P_REGULAR}
          component={H2}
          id={CHOOSE_ACCOUNT_TYPE_SUB_HEADER}
        >
          {intl.formatMessage(
            {
              id: CHOOSE_ACCOUNT_TYPE_SUB_HEADER,
            },
            {
              link: (
                <StyledAccountTypeLink
                  id={LOG_IN_LINK}
                  onClick={handleLoginClick}
                  component={BUTTON}
                  type={BUTTON}
                >
                  {intl.formatMessage({ id: LOG_IN_LINK })}
                </StyledAccountTypeLink>
              ),
            }
          )}
        </Typography>
      </Stack>
      <Box>
        <Grid container rowSpacing={3} columnSpacing={3}>
          <Grid item xs={12} md={6}>
            <AccountTypeCard
              icon={<StyledClipboardIcon id={CLIPBOARD_ICON_ID} />}
              header={FPACT_CARD_HEADER}
              subHeader={FPACT_CARD_SUB_HEADER}
              buttonText={START_NEW_APPLICATION_BUTTON}
              buttonId={START_NEW_APPLICATION_BUTTON}
              buttonClickHandler={handleStartApplicationBtnClick}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <AccountTypeCard
              icon={<StyledHAPIcon id={HAP_ICON_ID} />}
              header={HAP_CARD_HEADER}
              subHeader={HAP_CARD_SUB_HEADER}
              buttonText={LINK_MY_APPLICATION_BUTTON}
              buttonId={LINK_MY_APPLICATION_BUTTON}
              buttonClickHandler={handleLinkApplicationBtnClick}
            />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};
export default ChooseAccountType;
